export const TourPlan = {
    path: '/tour_plans',
    name: 'tour_plans',
    component: () => import('@/views/TourPlan/TourPlanPage.vue'),
    children: [
        {
            path: '/tour_plans/add',
            name: 'tour_plans.add',
            component: () => import('@/views/TourPlan/Form/TourPlanForm.vue'),
            props: {addAction: true},
        },
        {
            path: '/tour_plans/edit/:id',
            name: 'tour_plans.edit',
            component: () => import('@/views/TourPlan/Form/TourPlanForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/tour_plans/delete/:id',
            name: 'tour_plans.delete',
            component: () => import('@/views/TourPlan/Form/TourPlanForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/tour_plans/view/:id',
            name: 'tour_plans.view',
            component: () => import('@/views/TourPlan/Form/TourPlanForm.vue'),
            props: {viewAction: true}
        },
    ]
}

export const TourPlanCalendar = {
    path: '/tour_plan_calendar',
    name: 'tour_plan_calendar',
    component: () => import('@/views/TourPlan/TourPlanCalendarPage.vue'),
    children: [
        {
            path: '/tour_plan_calendar/add',
            name: 'tour_plan_calendar.add',
            component: () => import('@/views/TourPlan/Form/TourPlanForm.vue'),
            props: {addAction: true},
        },
        {
            path: '/tour_plan_calendar/view/:id',
            name: 'tour_plan_calendar.view',
            component: () => import('@/views/TourPlan/Form/TourPlanForm.vue'),
            props: {viewAction: true}
        },
    ]
}